export const URL = {
  TELL_ME_ABOUT_DISPLAY_EXAMPLE_OF_FISHERY_PRODUCT:
    'https://www.caa.go.jp/policies/policy/food_labeling/information/pamphlets/assets/food_labeling_cms201_240902_02.pdf#page=8',
};
